import { SplitFactory, SplitTreatments } from "@splitsoftware/splitio-react";

import { captureFeatureFlag } from "datadog-loader/loader";

import { getSplitIOFlag } from "splitio-loader/src/utils/get-split-io-flag";
import { impressionListener } from "splitio-loader/src/utils/impression-listener";

type InitParams = {
  authKey: string;
  userKey?: string;
};

let splitSDKPromise: Promise<SplitIO.IBrowserSDK>;

/**
 * Feature Flags - Promise for control of overall split.io ready status
 */
let splitSDK: SplitIO.IBrowserSDK | undefined;
let midUserKey: string | undefined;

export const getSplitIOSDKLoader: () =>
  | SplitIO.IBrowserSDK
  | undefined = () => {
  return splitSDK;
};

export const getSplitIOClient: () =>
  | SplitIO.IBrowserClient
  | undefined = () => {
  // TODO make this empty
  return splitSDK?.client();
};

export const SplitIOSDKLoader = ({ authKey, userKey }: InitParams) => {
  if (splitSDK && userKey === midUserKey) {
    return Promise.resolve(splitSDK);
  }
  midUserKey = userKey || "key";

  let splitReadyPromiseResolve: (sdk: SplitIO.IBrowserSDK) => void = () => null;
  let splitReadyPromiseReject: (reason?: unknown) => void = () => null;
  splitSDKPromise = new Promise<SplitIO.IBrowserSDK>((resolve, reject) => {
    splitReadyPromiseResolve = resolve;
    splitReadyPromiseReject = reject;
  });

  // To start a merchant key is required
  // TODO this might change to checkoutSessionData
  splitSDK = SplitFactory({
    core: {
      authorizationKey: authKey,
      key: midUserKey, // NOTE: We will need to change this if we wanted to target specific TBD segments.
      // trafficType: "user", // SPLITSDK - Move to tracking events
    },
    impressionListener: {
      logImpression: (data) => {
        impressionListener({ data, captureFeatureFlag });
      },
    },
    startup: {
      readyTimeout: 1.5, // seconds
    },
    // Overwrites the initial consent status of the factory instance, which is 'GRANTED' by default.
    // 'UNKNOWN' status represents that the user has neither granted nor declined consent for tracking data,
    // so the SDK will locally track data but not send it to Split cloud until consent is changed to 'GRANTED'.
    userConsent: "UNKNOWN",
    debug: false,
  });
  const splitUserClient = splitSDK.client();
  splitUserClient.on(splitUserClient.Event.SDK_READY, () => {
    if (splitSDK) {
      splitReadyPromiseResolve(splitSDK);
    }
  });
  splitUserClient.on(splitUserClient.Event.SDK_READY_TIMED_OUT, () => {
    splitReadyPromiseReject(false);
  });

  return splitSDKPromise;
};

const getSplitIOSDKPromise: () => Promise<SplitIO.IBrowserSDK> = () => {
  return splitSDKPromise;
};

export const clearSplitIOInstance = () => {
  splitSDK = undefined;
};
// TODO we might need the ability to re-init, destroy or modify in the future.

// Export items we use from splitIO
export { SplitFactory, SplitTreatments, getSplitIOFlag, getSplitIOSDKPromise };
